<template>
  <v-row>
      <div id="cart3Form">

      </div>
        <!-- <v-col cols="12" lg="8" order="12" order-lg="1">
            <v-card>
                <v-card-text>
                    <v-container>
                        <div>
                            <PortfolioSteps :current-step="3"></PortfolioSteps>
                            <section class="sec-top">
                                <h5 class="text-family text-h6 text-uppercase">Tarjetas Crédito y Débito</h5>
                                <v-divider class="my-2"></v-divider>
                                <div class="row credit-cards mt-2">
                                    <div class="btn-group-vertical col-md-6 col-7 btn-pago" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago btn-lg"><img class="picture-bank" src="../../../../assets/img/visa-mc.png" data-src="credit/visa-mc.png" data-sel="credit/visa-mc1.png"></button>
                                    </div>
                                    <div class="btn-group-vertical col-md-6 col-7 btn-pago" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago btn-lg"><img class="picture-bank" src="../../../../assets/img/visa-mc.png" data-src="credit/visa-mc.png" data-sel="credit/visa-mc1.png"></button>
                                    </div>
                                </div>
                            </section>

                        </div>
                    </v-container>
                </v-card-text>
            </v-card>

            <v-card class="mt-6">
                <v-card-text>
                    <v-container>
                        <div>
                            <section class="sec-middle">
                                <h5 class="text-family text-h6 text-uppercase">referencia bancaria</h5>
                                <v-divider class="my-2"></v-divider>
                                <h5 class="text-family justify-center d-flex">Su pago podrá ser recibido en las siguientes sucursales bancarias </h5>
                                <div class="row credit-cards mt-2">
                                    <div class="col-md-12 col-7 justify-center d-flex" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago font-weight-black">GENERAR REFERENCIA</button>
                                    </div>
                                    <h5 class="text-family mx-auto">Revisa las opciones que tenemos para realizar tu pago <a>aquí</a></h5>
                                </div>
                            </section>

                        </div>
                    </v-container>
                </v-card-text>
            </v-card>

            <v-card class="mt-6">
                <v-card-text>
                    <v-container>
                        <div>
                            <section class="sec-middle">
                                <h5 class="text-family text-h6 text-uppercase">Realiza tu pago en las siguientes tiendas de conveniencia:</h5>
                                <v-divider class="my-2"></v-divider>
                                <div class="row credit-cards mt-2">
                                    <div class="col-md-4 col-7 justify-center d-flex" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago"><img width="50%" class="img-grey" src="../../../../assets/img/Oxxo_Logo.svg"></button>
                                    </div>
                                    <div class="col-md-4 col-7 justify-center d-flex" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago"><img class="img-grey" width="50%" src="../../../../assets/img/telecom.svg"></button>
                                    </div>
                                    <div class="col-md-4 col-7 justify-center d-flex" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago"><img class="img-grey" width="50%" src="../../../../assets/img/7eleven.png"></button>
                                    </div>
                                </div>
                            </section>

                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
            
            <v-card class="mt-6">
                <v-card-text>
                    <v-container>
                        <div>
                            <section class="sec-middle">
                                <h5 class="text-family text-h6 text-uppercase">Utiliza tu banca en línea de los siguientes bancos:</h5>
                                <v-divider class="my-2"></v-divider>
                                <div class="row credit-cards mt-2">
                                    <div class="col-md-4 col-7 justify-center d-flex" role="group">
                                            <button id="vmc-netpay" type="button"  class="btn btn-border-pago"><img class="img-grey" width="50%" src="../../../../assets/img/Citibanamex.png"></button>
                                    </div>
                                    <div class="col-md-4 col-7 justify-center d-flex" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago"><img class="img-grey" width="50%" src="../../../../assets/img/BBVA.png"></button>
                                    </div>
                                    <div class="col-md-4 col-7 justify-center d-flex" role="group">
                                            <button id="vmc-netpay" type="button" class="btn btn-border-pago"><img class="img-grey" width="50%" src="../../../../assets/img/scotiabank.png"></button>
                                    </div>
                                </div>
                            </section>

                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col  cols="12" lg="4" order="1" order-lg="12">
            <Checkout
                v-if="cartStore.cart2Data"
                :checkout-data="cartStore.cart2Data.tramitesCheckout"
                :checkout-total="cartStore.cart2Data.checkoutTotal"
                :checkout-items-number="countCheckout2Items"
                :submit-cart="submitCart2"
                :show-all-items="showCheckoutAllItems"
            ></Checkout>
        </v-col>
        <ErrorModal
            :close-error-modal="closeErrorModal"
            :show-modal="showErrorModal"
            :message-code="errorCode"
        /> -->
  </v-row>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import {cart3Request} from "bestgob-core/api/models";
    import * as Storage from 'bestgob-core/core/storage.js'
    import {createOrderRequest} from "bestgob-core/api/models";
    import Vue from 'vue';
    // import Checkout from "../Checkout";
    // import PortfolioSteps from "../PortofolioSteps";
    // import ErrorModal from "../Cart2/ErrorModal";



    export default {
        name: "Cart3",
        data(){
            return{
                showErrorModal: false,
                errorCode: 0,
                cartFinalData: {},
            }
        },
        mounted() {
            this.initCart3Data()
            // this.clickedOnPago();
        },
        computed: {
           ...mapState({ordersStore: state => state.orders, cartStore: state => state.cart}),
            ...mapGetters('orders', ['order', 'proceduresGroup', 'paymentResponse'])

        },

        watch: {
            '$store.state.cart.cart3Data'(){
                this.prepareAndRedirectToCreateOrder()
            },
            '$store.state.orders.paymentResponse'(){
                this.$forceUpdate();
                if (this.ordersStore.paymentResponse != null && this.ordersStore.paymentResponse.content && this.ordersStore.paymentResponse.success ){
                    var miaction = document.implementation.createHTMLDocument(); // Sandbox
                    var cart3 =  document.getElementById('cart3Form');
                    miaction.body.innerHTML = this.ordersStore.paymentResponse.content; // Parse HTML properly
                    cart3.insertAdjacentHTML('beforeend', this.ordersStore.paymentResponse.content)
                    this.$forceUpdate();
                    Vue.nextTick(function () {
                        document.getElementById("miaction").submit();
                    })
                }
            }
        },

         components: {
            // Checkout, ErrorModal, PortfolioSteps
        },

        methods: {
            ...mapActions('cart', ['getCartStep3']),
            ...mapActions('orders', ['createOrder']),
            ...mapActions('alerts', ['error']),

            initCart3Data(){
                let request = cart3Request()
                request.cart3 = JSON.parse(Storage.getItem('cart3'))

                console.log("Cart 3")
                console.log(JSON.stringify(request.cart3))

                if (request.cart3 == null){
                    this.error('Hubo un error al continuar con el proceso del portafolio, vuelve a iniciar.')
                    this.$router.push({name: 'portfolio', params: {step: 1}})
                    return
                }else {
                    //VueX call
                    this.getCartStep3(request)
                    // this.createOrder()
                }
            },

            prepareAndRedirectToCreateOrder(){
                let cart = {}
                let dataInvoice = {}

                this.cartStore.cart3Data.facturas.forEach((invoice) => {
                    invoice.tramites.forEach((procedure, index2) => {
                        if (invoice.dato_fiscal){
                            if (!cart[''+invoice.dato_fiscal.id]){
                                cart[''+invoice.dato_fiscal.id] = {}
                            }

                            cart[''+invoice.dato_fiscal.id][''+index2] = procedure.tramite.id
                        }else {
                            if (!cart['0']){
                                cart['0'] = {}
                            }

                            cart['0'][''+index2] = procedure.tramite.id
                        }

                        if (procedure.tramite.facturable == 1){
                            if (procedure.datos_factura){
                                if (invoice.dato_fiscal){
                                    dataInvoice[''+procedure.tramite.id] = procedure.datos_factura.id
                                }else {
                                    dataInvoice['0'] = procedure.datos_factura.id
                                }
                            }
                        }
                    })
                })

                Storage.setItem('finalCart', JSON.stringify(cart))
                Storage.setItem('finalCartInvoice', JSON.stringify(dataInvoice))

                this.initCreateOrder()

                // this.clickedOnPago();
                // this.$router.push({name: 'orders', params: {action: 'create'}})
            },
            closeErrorModal() {
                this.showErrorModal = false
            },

            initCreateOrder(){
            let request = createOrderRequest()
            request.cart = JSON.parse(Storage.getItem('finalCart'))
            request.data_invoice = JSON.parse(Storage.getItem('finalCartInvoice'))
            request.url_return = this.getPaymentResponseUrl()

            //VueX call
            this.createOrder(request)

            this.removeCartSession()
            },
            getPaymentResponseUrl(orderId = 'order_id'){
                const route = {name: 'orders_details', params: {action:'payment_response', id: orderId}}
                return window.location.origin + this.$router.resolve(route).href
            },

            removeCartSession(){
                Storage.removeItem('finalCart')
                Storage.removeItem('finalCartInvoice')
                Storage.removeItem('cart1')
                Storage.removeItem('cart2')
                Storage.removeItem('cart3')
            },
            
        }
    }
</script>

<style>
.btn-group-vertical {
    height: 10em;
}
.credit-cards{
    display: flex;
}
.btn-pago{
    display: flex;
    justify-content: center;
}
.btn-border-pago{
    border: rgba(128, 128, 128, 0.446) 1px solid;
    border-radius: 4px;
    padding: 1rem;
}

.img-grey{
    filter: grayscale();
}

.v-sheet.v-stepper:not(.v-sheet--outlined){
    box-shadow: none  !important;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>